import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './font-awesome-library';
export default /*#__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'BaseIcon',
    props: {
        name: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(FontAwesomeIcon), _mergeProps(_ctx.$attrs, { icon: _ctx.name }), null, 16, ["icon"]));
        };
    }
});
